<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-acl="RMC_PROD_AUDITOR_SAVE" v-if="rmcProduceAuditorId==='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')">保存</el-button>
        <!-- <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-acl="RMC_PROD_AUDITOR_SAVE" v-if="rmcProduceAuditorId!=='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')">保存</el-button> -->
        <!-- <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROD_AUDITOR_SUBMIT" v-if="detailForm.auditStatus!=='PendingApproval'">提交</el-button> -->
        <!-- <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-if="isShowAddSave" v-acl="RMC_PROD_AUDITOR_SAVE">保存</el-button> -->
        <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-if="isShowEditSave" v-acl="RMC_PROD_AUDITOR_SAVE">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-if="isShowSub" v-acl="RMC_PROD_AUDITOR_SUBMIT">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROD_AUDITOR_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">批准</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROD_AUDITOR_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">退回</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="140px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">审核员清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code">
                  <el-select v-model="detailForm.category3Code" :disabled="isDisabled||isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" readonly placeholder="从供应商集团选择">
                    <el-button @click="onFacility" slot="append" icon="el-icon-search" :disabled="isSponsor||isForbidden"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Farm Group" prop="farmGroupId" :rules="rules.farmGroupId" :class="(isSponsor&&!(detailForm.auditorType.length === 1 &&detailForm.auditorType[0] === 'SecondParty'))?'is-required':''">
                  <el-select v-model="detailForm.farmGroupId" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in farmGroupOptions" :label="item.farmGroup" :value="item.rmcProduceFarmGroupId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核员" prop="auditorName" :rules="rules.auditorName" class="is-required">
                  <el-input v-model="detailForm.auditorName" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="性别" prop="auditorGender" :rules="rules.auditorGender" class="is-required">
                  <el-select v-model="detailForm.auditorGender" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in sexOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学历" prop="auditorEducation" :rules="rules.auditorEducation" class="is-required">
                  <el-select v-model="detailForm.auditorEducation" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in educationOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专业" prop="auditorMajor" :rules="rules.auditorMajor" class="is-required">
                  <el-input v-model="detailForm.auditorMajor" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="从业年限(农业相关)" prop="workYear" :rules="rules.workYear" class="is-required">
                  <el-input v-model="detailForm.workYear" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="审核员类型" prop="auditorType" :rules="rules.auditorType" class="is-required">
                  <el-select v-model="detailForm.auditorType" clearable multiple :disabled="isForbidden" placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in auditorTypeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="E-Learning" prop="elearning" :rules="rules.elearning" class="is-required">
                  <el-select v-model="detailForm.elearning" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in elearningOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核资质(多选)" prop="auditorQualification" :rules="rules.auditorQualification" class="is-required">
                  <el-select v-model="detailForm.auditorQualification" @change="auditorQualificationChange" clearable multiple :disabled="isForbidden" placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in auditorQualificationOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="MGG管理年限" prop="mmgManagerYear" :rules="rules.mmgManagerYear" class="is-required">
                  <el-input v-model="detailForm.mmgManagerYear" :disabled="isForbidden||isInput" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="审核员状态" prop="auditorStatus">
                  <el-select v-model="detailForm.auditorStatus" :disabled="isForbidden||(detailForm.auditStatus!=='Approved'&&detailForm.auditStatus!=='Returned')" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditorStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="auditStatus">
                  <el-select v-model="detailForm.auditStatus" disabled clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="$route.query.from === 'edit'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastUpdateReason">
                  <el-input v-model="lastUpdateReason" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="updateReason" :rules="rules.updateReason" class="is-required">
                  <el-input v-model="detailForm.updateReason" :disabled="isForbidden" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="Sponsor主数据" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <facilityList v-if="dialogVisible" @selectData="selectData"></facilityList>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import rmcProdAuditorApi from "@/api/rmcProduce/audit";
import facilityList from "../../Protein/ASL/facilityList.vue";
export default {
  name: "rmcProdAuditDetail",
  components: {
    IcSelect,
    facilityList,
  },
  data() {
    return {
      rmcProduceAuditorId: '',
      lastUpdateReason: "",
      detailInfo: null,
      ms_roles: null,
      dialogVisible: false,
      isDisabled: true,
      isForbidden: false,
      dialogReturnVisible: false,
      isShowSub: true,
      isShowEditSave: true,
      isInput: true,
      isSponsor: false,
      rules: {
        farmGroupId: [
          {
            validator: (rule, value, callback) => {
              if (!(this.detailForm.auditorType.length === 1 && this.detailForm.auditorType[0] === 'SecondParty')) {
                if (this.isSponsor && !value) {
                  this.$message.error('请选择Farm Group')
                  return callback(new Error(' '));
                };
              }
              callback();
            },
            trigger: "change"
          }
        ],
        mmgManagerYear: [
          {
            validator: (rule, value, callback) => {
              if (this.detailForm.auditorQualification.includes('MGG') && !value) {
                this.$message.error('请输入MGG管理年限')
                return callback(new Error(' '));
              }
              if (value) {
                var reg = /^[0-9]\d*$/
                if (!reg.test(value)) {
                  this.$message.error('请输入正整数或0')
                  return callback(new Error(' '));
                }
                var reg = /^.{1,100}$/
                if (!reg.test(value)) {
                  this.$message.error('字段“MGG管理年限”已超出数据库长度要求（长度：100），请删减.')
                  return callback(new Error(' '));
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        auditorName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入审核员')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“审核员”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        auditorGender: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择性别')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorEducation: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择学历')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorMajor: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入专业')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“专业”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        workYear: [
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                this.$message.error('请输入从业年限(农业相关)')
                return callback(new Error(' '));
              };
              var reg = /^[0-9]\d*$/
              if (!reg.test(value)) {
                this.$message.error('请输入正整数或0')
                return callback(new Error(' '));
              }
              var reg = /^.{1,10}$/
              if (!reg.test(value)) {
                this.$message.error('字段“从业年限(农业相关)”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        auditorType: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                this.$message.error('请选择审核员类型')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择审核员状态')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        elearning: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择E-Learning')
                return callback(new Error(' '));
              };
              // if (value) {
              //   console.log('detailForm.auditorType', this.detailForm.auditorType);
              //   console.log('value', value);
              //   if ((this.detailForm.auditorType.includes('SecondParty') || this.detailForm.auditorType.includes('ThirdParty')) && value === 'NonCompleted') {
              //     this.$message.error('审核员类型为二方或者三方审核员时，E-learning必须是完成；请检查。')
              //     return callback(new Error(' '));
              //   }
              // }
              callback();
            },
            trigger: "change"
          }
        ],
        auditorQualification: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                this.$message.error('请选择审核资质')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        updateReason: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入修改原因')
                return callback(new Error(' '));
              };
              var reg = /^.{0,1000}$/
              if (!reg.test(value)) {
                this.$message.error('字段“修改原因”已超出数据库长度要求（长度：1000），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
      },
      detailForm: {
        category3Code: "",
        sponsorName: "",
        farmGroupId: "",
        auditorName: "",
        auditorGender: "",
        auditorEducation: "",
        auditorMajor: "",
        workYear: "",
        auditorType: [],
        elearning: "",
        auditorQualification: [],
        mmgManagerYear: "",
        auditorStatus: "Effective",
        auditStatus: "",
        updateReason: "",
      },
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      tableData: [],
      ms_Permission: [],
      category3CodeOptions: [],//
      farmGroupOptions: [],//
      sexOptions: [],//
      educationOptions: [],//
      auditorTypeOptions: [],//
      elearningOptions: [],
      auditorQualificationOptions: [],
      auditorStatusOptions: [],//
      auditStatusOptions: [],//
      rmcProduceAuditorIds: [],
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.getSelection()
    this.rmcProduceAuditorId = this.$route.query.rmcProduceAuditorId
    if (this.$route.query.from === 'edit') {
      if (this.$route.query.rmcProduceAuditorId) {
        this.rmcProduceAuditorIds.push(this.$route.query.rmcProduceAuditorId)
      }
      this.getDetailInfo()
    } else {
      this.$set(this.detailForm, 'auditStatus', 'Draft')
      this.permissionJudge()
      this.getSponsorByUser()
      this.getAuthorizedCategory3()
    }
  },
  methods: {
    getDetailInfo() {
      rmcProdAuditorApi.getAuditorDetail(this.$route.query.rmcProduceAuditorId).then(res => {
        console.log('获取农场明细', res);
        this.detailForm = res.data
        this.rmcProduceAuditorId = res.data.rmcProduceAuditorId
        this.lastUpdateReason = res.data.updateReason
        this.detailForm.updateReason = ""
        if (res.data.auditorType) {
          this.detailForm.auditorType = res.data.auditorType.split(',')
        }
        if (res.data.auditorQualification) {
          this.detailForm.auditorQualification = res.data.auditorQualification.split(',')
          if (res.data.auditorQualification.includes('MGG')) {
            this.isInput = false
          } else {
            this.isInput = true
            this.detailForm.mmgManagerYear = ''
          }
        }
        this.permissionJudge()
        // if (res.data.auditStatus !== 'PendingApproval') {
        //   // this.$route.query.isCqs === 'N' && (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_SAVE') !== -1 || this.ms_Permission.indexOf('RMC_PROD_AUDITOR_SUBMIT') !== -1)
        //   if (this.$route.query.isCqs === 'N' && this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') === -1) {
        //     this.isForbidden = false
        //   } else if (this.$route.query.isCqs === 'Y' && this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') !== -1) {
        //     this.isForbidden = false
        //   } else {
        //     this.isForbidden = true
        //   }
        // } else {
        //   this.isForbidden = true
        // }
        this.getFarmGroupList(res.data.sponsorCode, res.data.farmGroupId);
      });
    },
    permissionJudge() {
      // CQS用户登录，展示按钮：拥有 RMC_PROT_AUDITOR_APPROVE权限 并且 isCqs=‘Y’
      if (this.$route.query.from === 'edit') {
        if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') !== -1 && this.$route.query.isCqs === 'Y' && this.detailForm.auditStatus !== 'PendingApproval') {
          this.isShowSub = true
          this.isForbidden = false
        } else if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') === -1 && this.$route.query.isCqs === 'N' && this.detailForm.auditStatus !== 'PendingApproval') {
          // 供应商用户登录，展示按钮： 没有RMC_PROT_AUDITOR_APPROVE 权限 并且 isCqs='N'
          this.isShowSub = true
          this.isForbidden = false
        } else {
          this.isShowSub = false
          this.isForbidden = true
        }
      } else {
        if (this.detailForm.auditStatus !== 'PendingApproval') {
          this.isShowSub = true
          this.isForbidden = false
        } else {
          this.isShowSub = false
          this.isForbidden = true
        }
      }
      if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') !== -1) {
        this.isSponsor = false
      } else {
        this.isSponsor = true
      }
      if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') !== -1 && this.$route.query.isCqs === 'Y' && this.rmcProduceAuditorId !== '0' && (!this.detailForm.auditStatus || this.detailForm.auditStatus === 'Draft')) {
        this.isShowEditSave = true
      } else if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') === -1 && this.$route.query.isCqs === 'N' && this.rmcProduceAuditorId !== '0' && (!this.detailForm.auditStatus || this.detailForm.auditStatus === 'Draft')) {
        // 供应商用户登录，展示按钮： 没有RMC_PROT_AUDITOR_APPROVE 权限 并且 isCqs='N'
        this.isShowEditSave = true
      } else {
        this.isShowEditSave = false
      }
    },
    onFacility() {
      this.dialogVisible = true
    },
    selectData(data) {
      console.log("获取的数据======", data)
      this.detailInfo = data
      this.$set(this.detailForm, 'sponsorName', data[0].supplierName)
      this.$set(this.detailForm, 'sponsorCode', data[0].supplierCode)
      this.$refs.detailForm.clearValidate('sponsorName');
      this.$set(this.detailForm, 'farmGroupId', "")
      this.getFarmGroupList(data[0].supplierCode)
      this.dialogVisible = false
    },
    auditorQualificationChange(val) {
      // console.log('val', val);
      // console.log('val', val.includes('MGG'));
      if (val.includes('MGG')) {
        this.isInput = false
      } else {
        this.isInput = true
        this.detailForm.mmgManagerYear = ''
      }
    },
    getSponsorByUser() {
      rmcProdAuditorApi.getSponsorByUser().then(res => {
        console.log('获取Sponsor', res);
        this.detailForm.sponsorName = res.data.supplierName
        this.detailForm.sponsorCode = res.data.supplierCode
        if (this.$route.query.from === 'add') {
          this.getFarmGroupList(res.data.supplierCode);
        }
      });
    },
    getFarmGroupList(sponsor, farmGroupId) {
      rmcProdAuditorApi.getFarmGroupList(sponsor).then(res => {
        console.log('获取Farm Group', res);
        this.farmGroupOptions = res.data
        var codeLists = res.data.map(ele => {
          return ele.rmcProduceFarmGroupId
        })
        console.log('codeLists', codeLists);
        if (farmGroupId && !codeLists.includes(farmGroupId)) {
          this.farmGroupOptions.push({
            rmcProduceFarmGroupId: this.detailForm.farmGroupId,
            farmGroup: this.detailForm.farmGroup,
            enabled: true,
            sponsorCode: sponsor,
          })
        }
        console.log('this.farmGroupOptions', this.farmGroupOptions);
      });
    },
    getAuthorizedCategory3() {
      rmcProdAuditorApi.getAuthorizedCategory3(this.$route.query.rmcProduceAuditorId).then(res => {
        console.log('获取category3', res);
        this.category3CodeOptions = res.data.filter((v) => {
          return v.cascadeKey === 'produce'
        })
        if (this.category3CodeOptions.length === 1) {
          this.detailForm.category3Code = this.category3CodeOptions[0].key
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    getSelection() {
      rmcProdAuditorApi.getSelection(['rmc.AuditorQualification', 'rmc.RmcELearningCompletion', 'rmc.RmcCategory3', 'rmc.RmcAuditorStatus', 'rmc.RmcAuditorType', 'rmc.RmcAuditStatus', 'Education', 'Gender']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'produce'
        })
        console.log('this.category3CodeOptions', this.category3CodeOptions);
        this.sexOptions = res.data['Gender'];
        this.educationOptions = res.data['Education'];
        this.auditorTypeOptions = res.data['rmc.RmcAuditorType'];
        this.auditorStatusOptions = res.data['rmc.RmcAuditorStatus'];
        this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
        this.elearningOptions = res.data['rmc.RmcELearningCompletion'];
        this.auditorQualificationOptions = res.data['rmc.AuditorQualification'];
      });
    },
    onAddSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if ((this.detailForm.auditorType.includes('SecondParty') || this.detailForm.auditorType.includes('ThirdParty')) && this.detailForm.elearning === 'NonCompleted') {
            this.$message.error('审核员类型为二方或者三方审核员时，E-learning必须是完成；请检查。')
            return false
          }
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            auditorName: this.detailForm.auditorName,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            elearning: this.detailForm.elearning,
            auditorQualifications: this.detailForm.auditorQualification,
            mmgManagerYear: this.detailForm.mmgManagerYear,
            auditorStatus: this.detailForm.auditorStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProdAuditorApi.addAuditor(obj).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProdAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onEditSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if ((this.detailForm.auditorType.includes('SecondParty') || this.detailForm.auditorType.includes('ThirdParty')) && this.detailForm.elearning === 'NonCompleted') {
            this.$message.error('审核员类型为二方或者三方审核员时，E-learning必须是完成；请检查。')
            return false
          }
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            auditorName: this.detailForm.auditorName,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            elearning: this.detailForm.elearning,
            auditorQualifications: this.detailForm.auditorQualification,
            mmgManagerYear: this.detailForm.mmgManagerYear,
            auditorStatus: this.detailForm.auditorStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProdAuditorApi.updateAuditor(this.rmcProduceAuditorId, obj).then(res => {
            console.log('更新', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProdAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onSubmit() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if ((this.detailForm.auditorType.includes('SecondParty') || this.detailForm.auditorType.includes('ThirdParty')) && this.detailForm.elearning === 'NonCompleted') {
            this.$message.error('审核员类型为二方或者三方审核员时，E-learning必须是完成；请检查。')
            return false
          }
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            auditorName: this.detailForm.auditorName,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            elearning: this.detailForm.elearning,
            auditorQualifications: this.detailForm.auditorQualification,
            mmgManagerYear: this.detailForm.mmgManagerYear,
            auditorStatus: this.detailForm.auditorStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProdAuditorApi.submitAuditor(this.rmcProduceAuditorId, obj).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('提交成功')
              this.$router.push('/rmcProdAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onApprove() {
      rmcProdAuditorApi.approveAuditor({
        rmcProduceAuditorIds: this.rmcProduceAuditorIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$router.push('/rmcProdAuditor')
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProdAuditorApi.returnAuditor({
            rmcProduceAuditorIds: this.rmcProduceAuditorIds,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.onClose()
              this.$router.push('/rmcProdAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onClose() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>